<template>
	<v-dialog
			:value="isViewDocumentsTypes"
			content-class="dialogWrapper"
			fullscreen
			hide-overlay
			transition="dialog-bottom-transition"
	>
		<div class="dialogWrap">
			<div class="dialogTitle">
				<span>View documents types</span>
				<button type="button" @click="onClose">
					<svg-sprite width="20" height="20" icon-id="close"></svg-sprite>
				</button>
			</div>
			<div class="dialogMain">
				<div class="fieldWrapper">
					<field
							:class-error="getError('name')"
							margin="0"
							width="100%"
							label="DocumentsTypes name"
							placeholder="Enter documents types name"
							:setInputValue="name"
							@updateInput="onInput($event, 'name')"
							is-required
					></field>
				</div>
				<div class="main">

				</div>
				<div class="footer">
					<custom-btn
							text="Save"
							@updateEvent="onSave"
							custom-class="apply"
							is-all-elements
							margin='0'
							:icon-attrs="{width: 20, height: 20, iconId: 'safe'}"
					></custom-btn>
					<custom-btn
							text="Close"
							@updateEvent="onClose"
							is-all-elements
							margin='0'
							:icon-attrs="{width: 20, height: 20, iconId: 'close'}"
					></custom-btn>
				</div>
			</div>
		</div>
		<preload v-if="isPreloader"></preload>

	</v-dialog>
</template>

<script>

import Vue from 'vue';

// Prefered: as a plugin (directive + filter) + custom placeholders support
import VueMask from 'v-mask';
Vue.use(VueMask);

// validation
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";

import { mapActions } from "vuex";
import Preload from "@/shared/Preload/Preload.vue";
export default {
	name: "ViewDocumentsTypes",
	components: { Preload },
	mixins: [ validationMixin ],
	props: {
		dialogFlag: String,
		editDocumentsTypes: Object,
	},
	validations: {
		name: { required },
	},
	data: () => ({
		isViewDocumentsTypes: true,
		name: null,
		id: null,
		isPreloader: false,
	}),

	methods: {
		...mapActions([ 'setAlert', 'onAccountDocumentsTypesSave', 'onAccountDocumentsTypesEdit' ]),

		onInput({ value }, key) {
			this[key] = value;
		},
		onTime(value, key) {
			this[key] = value;
		},

		async onSave() {
			this.isPreloader = true;

			this.$v.$touch();
			if (!this.$v.$error) {
				const { name, id } = this.$data;
				const sendInfo = { name };

				if (this.dialogFlag === 'add') {
					await this.onAccountDocumentsTypesSave({ sendInfo });
				} else {
					await this.onAccountDocumentsTypesEdit({ sendInfo, id });
				}
				this.$emit('updateClose');
				this.$emit('updateList');
			} else {
				await this.setAlert({ type: "error", message: "Saving error" });
			}
			this.isPreloader = false;

		},

		onClose() {
			this.$emit('updateClose');
		},

		getError(key) {
			return this.$v && this.$v[key] && this.$v[key].$error;
		},
	},
	mounted() {
		this.isPreloader = true;

		if (this.dialogFlag === 'add') {
			this.name = null;
			this.id = null;
		} else {
			this.name = this.editDocumentsTypes.name;
			this.id = this.editDocumentsTypes.id;
		}

		this.isPreloader = false;
	},
};
</script>

<style scoped lang="scss">
@import "../ViewVersion/ViewVersion";
</style>
